'use strict';
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');
var MiscInfo = require('models/misc_info');

function hasMisc() {
    if (!AppState.isRestricted()) return true;

    var avail = AppState.availableFields(undefined, Consts.FieldGroup.Meta);
    return (
        Misc.countWhere(avail, function (x) {
            return x.field_type == 2;
        }) > 0
    );
}

var InfoManagementView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/info_management'),
    controller: undefined,
    model: {},

    events: {
        'click .js-modal_management_edit': 'showManagementDialogEdit',
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: ['.js-modal_management_edit'],

            getDeviceID: function (view) {
                return view.getOption('model').get('id');
            },
        },
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.errors = {};
        this.readOnly = options.features[Consts.Features.ManagementInfoReadonly] || false;
        this.modelInfo = options.model.get('info') || {};
        this.modelInfo.miscInfo = options.miscInfo ? options.miscInfo.toJSON() : {};
        this.canEditMisc = hasMisc();
    },

    setPermission: function (permissions) {
        this.readOnly = this.readOnly || permissions.get(Consts.Permissions.Info);
    },

    showManagementDialogEdit: function (e) {
        e.preventDefault();
        var fieldId = $(e.currentTarget).attr('field-id');

        var dataSources = {
            address: this.modelInfo.address,
            contactperson: this.modelInfo.contact_person,
            miscinfo: this.modelInfo.miscInfo,
        };
        var dataModel = new MiscInfo(dataSources[fieldId]);
        dataModel.set('id', this.model.id);

        this.controller.showManagementDialogEdit(
            function (updatedModel) {
                // reload current route to ensure consistent view
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            fieldId,
            dataModel
        );
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.canEditMisc = this.canEditMisc;
        data.isReadOnly = this.readOnly;
        data.errors = this.errors;

        // merges two maps into a new one:
        // {key:name} + {key:value} -> {name:value}
        function makeTemplateInfo(map, content) {
            var result = {};
            if (content != undefined) {
                _.each(map, function (value, key) {
                    if (content[key]) {
                        result[value] = content[key];
                    }
                });
            }
            return result;
        }

        var map = {
            street: i18n.TR('Strasse'),
            number: i18n.TR('Nummer'),
            code: i18n.TR('Postleitzahl'),
            city: i18n.TR('Stadt'),
            country: i18n.TR('Land'),
            name: i18n.TR('Name'),
            phone: i18n.TR('Telefonnummer'),
            email: i18n.TR('E-Mail'),
        };

        data.address = makeTemplateInfo(map, this.modelInfo.address);
        data.contactperson = makeTemplateInfo(map, this.modelInfo.contact_person);
        data.miscinfo = this.modelInfo.miscInfo;

        return data;
    },
});

module.exports = InfoManagementView;
